<template>
  <div class="phonebg"  v-if="visble">
    <div class="jiudian">
      <div class="title">早餐扫码</div>
    </div>
    <!-- <div class="weixin">
      <div class="content">
        <div><img class="face" :src="wxuser.headimgurl" /></div>
        <div class="name" v-html="wxuser.nickname"></div>
      </div>
    </div> -->
    <div class="weixin">
      <div v-if="roomInfo.status == '200'" class="title" style="color:green;">本次早餐扫码成功</div>
      <div v-else class="title" style="color:red;">本次早餐扫码失败</div>
      <div class="title" v-if="roomInfo.status != '200'">{{roomInfo.message}}</div>
      <div class="content">
          <div class="userinfo">
            <div><span class="fizeweight">房号：</span>{{roomInfo.data.roomNo}}</div>  
              <div>{{roomInfo.data.roomType}}<span class="fizeweight">：房型</span></div>  
          </div>
          <div class="userinfo">
            <div><span class="fizeweight">姓名：</span>{{roomInfo.data.guestName}}</div>
             <div>{{roomInfo.data.accNo}}<span class="fizeweight">：账号</span></div>    
          </div>
        <div style="display: flex; justify-content: space-around; margin-top:2em;">
          <div><span class="fizeweight">早餐总计：</span><b>{{roomInfo.data.total}}</b>份</div>  
          <div><span class="fizeweight">已使用：</span><b style="color:red;">{{roomInfo.data.use}}</b>份</div>  
          <div><span class="fizeweight">剩余：</span><b style="color:green;">{{roomInfo.data.available}}</b>份</div>  
        </div>
      </div>
       <div class="smlist">
         <div class="title">{{roomInfo.data.roomNo}} 房间 早餐扫码记录</div>
         <div v-for="(item, index) in roomInfo.data.breakfastList"
              :key="index"
            >
            {{item.createtime}}
         </div>

       </div>
      
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/api1.js";
import global from "../../Global.vue";
export default {
  name: "welcome",
  data() {
    return {
      image_base: this.$store.state.api,
      // wxuser: {
      //   openid: "oxIGSt-OMGpAhbCPKxshFtfgP8ns",
      //   nickname: "星星",
      //   sex: 1,
      //   language: "zh_CN",
      //   city: "南京",
      //   province: "江苏",
      //   country: "中国",
      //   headimgurl: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKdiaoRgUBW4hcibV4KrpMj2iaNqibcDrN6ibux1I5vtgVxD2QmDjyNlRVsELc6vrRpJ5IONsp8nokZDKQ/132",
      //   subscribe:0,
      //   unionid:"oLcaa6Y3LnaRvGpxTk-Qe04OkICk",
      // },
      wxuser:{},
      roomInfo:{},
      visble:false,
    };
  },
  created() {
    if (this.$route.query.j == null || this.$route.query.j == "") {
      alert("未获取到加盟号！");
      return;
    }
    if (this.$route.query.g == null || this.$route.query.g == "") {
      alert("未获取到宾客信息！");
      return;
    }
    //this.checkUserSaoMa();
    this.getCode();
    
  },
  mounted() {},
  methods: {
    
    getCode() {
      // 非静默授权，第一次有弹框
      const code = this.getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      const local = window.location.href;
      const APPID = "wxe85988fe337541a9"; // 企业微信
      if (code == null || code == "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      } else {
        this.getOpenId(code); //把code传给后台获取用户信息
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    getOpenId(code) {
      let loadingInstance = this.$loading({ text: "正在加载用户..." });
      let param = {
        code: code,
      };
      postRequest("/getwxuser", param).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.wxuser = res.data;
          this.checkUserSaoMa();
          // if(res.data.subscribe == 1){
          //    //获取酒店用户信息
          //   //this.doBangding();
          // }else{
          //  // this.$router.push("/guanzhu?message=绑定失败,请先关注公众号后在扫码绑定");
          // }
        } else {
          alert(res.message);
        }
      });
    },
    checkUserSaoMa(){
      let loadingInstance = this.$loading({ text: "早餐管理人员身份识别中..." });
      let parm = {};
      parm.joinCode = this.$route.query.j;
      parm.unionId = this.wxuser.unionid;
      this.axios.post(global.pmsapi + "checkBreakfastRight", parm).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          if(res.data.status == 200 && res.data.data){
            this.readZaoCan();
          }else{
             alert(res.data.message);
          }
        } else {
          //alert(1234)
          alert(res.message);
        }
      });
    },
    readZaoCan() {
      let loadingInstance = this.$loading({ text: "正在读取早餐..." });
      let parm = {};
      parm.joinCode = this.$route.query.j;
      parm.guestId = parseInt(this.$route.query.g);
      this.axios.post(global.pmsapi + "addBreakfast", parm).then((res) => {
         this.$nextTick(() => {
          loadingInstance.close();
        });
        var data = res.data;
        if (data.status == 200) {
          this.visble = true;
          this.roomInfo = data;
        } else {
          this.visble = true;
          this.roomInfo = data;
          alert(data.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.smlist{
  width: 100%;
  text-align: center;
  line-height: 2rem;
  margin-top: 1rem;
}
.userinfo{
  display: flex;
    justify-content: space-between;
    height: 4rem;
    line-height:  4rem;
    font-size: 1rem;;
}
b{
  font-weight: bold;
  font-size: 1.6rem;
}
.fizeweight {
  font-weight: bold;
}
.phonebg {
  background: linear-gradient(0deg, #d6ebff 0%, #e9f4ff 48%, #d6ebff 100%);
  /* background: linear-gradient(180deg, #D6EBFF, #E9F4FF 48%, #D6EBFF); */
}
.jiudian {
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  height: 3rem;
  line-height: 3rem;
}
.content {
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding: 5%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  /* box-shadow: 8px 8px 20px #b9ccec inset, -8px -8px 15px #ffffff inset; */
  text-align: center;
}

.weixin,
.user {
  margin-top: 1rem;
  position: relative;
}
.name {
  font-weight: bold;
  font-size: 1.2rem;
}

.face {
  width: 4rem;
  border-radius: 100%;
}
.contentuser {
  display: flex;
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding: 3%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}

.divface {
  margin-right: 3%;
}
.faceuser {
  width: 4rem;
  height: 5rem;
  margin-top: 6%;
}

.qrbd {
     width: 30%;
    color: #4bb0ff;
    text-align: center;
    border-radius: 0.2em;
    box-shadow: 5px 5px 20px #a2b3dc, -5px -5px 20px #ffffff;
    left: 35%;
    bottom: 10%;
    height: 2rem;
    line-height: 2rem;
    position: fixed;
}
</style>